module.exports = __webpack_public_path__ + "media/components/navigation/static/logo-d8f0bf12bfed735781e074dbb56fd6b2.png";